import { render, staticRenderFns } from "./channelrebate.vue?vue&type=template&id=a1068e72&scoped=true&"
import script from "./channelrebate.vue?vue&type=script&lang=js&"
export * from "./channelrebate.vue?vue&type=script&lang=js&"
import style0 from "./channelrebate.vue?vue&type=style&index=0&id=a1068e72&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a1068e72",
  null
  
)

export default component.exports